/** @format */

import { request } from '@power/runtime-vue3';

const BASE_PATH = '/power-model';
/**
 * @description 获取资源树数据
 * @returns
 */
export function getResList(params) {
	return request(
		{
			url: `${BASE_PATH}/restype/treelist`,
			method: 'get',
			params,
		},
		{
			isGetDataDirectly: false,
		},
	);
}

export function addRes(data) {
	return request(
		{
			url: `${BASE_PATH}/restype`,
			method: 'post',
			data,
		},
		{
			isGetDataDirectly: false,
		},
	);
}

export function editRes(data) {
	return request(
		{
			url: `${BASE_PATH}/restype`,
			method: 'put',
			data,
		},
		{
			isGetDataDirectly: false,
		},
	);
}

export function delRes(data) {
	return request(
		{
			url: `${BASE_PATH}/restype/${data.objectid}`,
			method: 'delete',
			data,
		},
		{
			isGetDataDirectly: false,
		},
	);
}

export function orderRes(data) {
	return request(
		{
			url: `${BASE_PATH}/restype/order`,
			method: 'put',
			data,
		},
		{
			isGetDataDirectly: false,
		},
	);
}

export function getResObjectList(data) {
	const { requestUrl, ...otherData } = data;
	return request(
		{
			url: requestUrl ? requestUrl : `${BASE_PATH}/resobject/list`,
			method: 'post',
			data: otherData,
		},
		{
			isGetDataDirectly: false,
		},
	);
}

export function addResObject(data) {
	return request(
		{
			url: `${BASE_PATH}/resobject`,
			method: 'post',
			data,
		},
		{
			isGetDataDirectly: false,
		},
	);
}

export function getResObject(params) {
	return request(
		{
			url: `${BASE_PATH}/resobject/${params.objectid}`,
			method: 'get',
			params,
		},
		{
			isGetDataDirectly: false,
		},
	);
}

export function editResObject(data) {
	return request(
		{
			url: `${BASE_PATH}/resobject`,
			method: 'put',
			data,
		},
		{
			isGetDataDirectly: false,
		},
	);
}

export function delResObject(data) {
	return request(
		{
			url: `${BASE_PATH}/resobject`,
			method: 'delete',
			data,
		},
		{
			isGetDataDirectly: false,
		},
	);
}

export function exportResObjectList() {
	return `${BASE_PATH}/resobject/export`;
}

export function getAllHistory(data) {
	return request(
		{
			url: `${BASE_PATH}/resobject/getAllHistory`,
			method: 'post',
			data,
		},
		{
			isGetDataDirectly: false,
		},
	);
}

export function getHistoryCompare(data) {
	return request(
		{
			url: `${BASE_PATH}/resobject/historyCompare`,
			method: 'post',
			data,
		},
		{
			isGetDataDirectly: false,
		},
	);
}

export function importResource(data) {
	return request(
		{
			url: `${BASE_PATH}/resobject/import`,
			method: 'post',
			data,
			headers: { 'Content-Type': 'multipart/form-data' },
		},
		{
			isGetDataDirectly: true,
		},
	);
}

export function exportTemplate() {
	return `${BASE_PATH}/resobject/export/template`;
}

export function getModel(params) {
	return request(
		{
			url: `${BASE_PATH}/resmodel/${params.objectid}`,
			method: 'get',
			params: {
				bussinessCode: params.bussinessCode,
			},
		},
		{
			isGetDataDirectly: false,
		},
	);
}

export function getBussinessList(params) {
	return request(
		{
			url: `${BASE_PATH}/bussiness/list`,
			method: 'get',
			params,
		},
		{
			isGetDataDirectly: false,
		},
	);
}
